!function(){
  if(window.__MIAYMIA_FSB_INIT)return;
  window.__MIAYMIA_FSB_INIT=!0;

  const bar=document.getElementById("miaymia-fsb");
  if(!bar)return;

  const threshold=Number(bar.dataset.thresholdCents||3000);
  const textNode=bar.querySelector("[data-miaymia-fsb-text]");
  const fillNode=bar.querySelector("[data-miaymia-fsb-fill]");

  let resizeFrame=null;
  let refreshTimer=null;
  let lastBarHeight=-1;
  let lastTotal=null;
  let fetchInFlight=false;
  let refreshQueued=false;

  function formatMoney(cents){
    return `${(cents/100).toFixed(2).replace(".",",")} €`;
  }

  function applyBarOffset(){
    resizeFrame=null;
    const nextHeight=Math.ceil(bar.getBoundingClientRect().height);
    if(nextHeight!==lastBarHeight){
      lastBarHeight=nextHeight;
      document.documentElement.style.setProperty("--miaymia-fsb-offset",`${nextHeight}px`);
    }
  }

  function scheduleOffset(){
    if(!resizeFrame){
      resizeFrame=window.requestAnimationFrame(applyBarOffset);
    }
  }

  async function refreshCart(){
    if(fetchInFlight){
      refreshQueued=!0;
      return;
    }

    fetchInFlight=!0;
    refreshQueued=!1;

    try{
      const response=await fetch("/cart.js",{
        headers:{Accept:"application/json"},
        cache:"no-store"
      });
      const cart=await response.json();
      const total=Number(cart.total_price||0);

      if(lastTotal!==total){
        lastTotal=total;
        const missing=Math.max(0,threshold-total);
        const progress=Math.max(0,Math.min(100,(total/threshold)*100));

        if(textNode){
          textNode.textContent=missing>0
            ? `🚚✨ ¡FALTAN ${formatMoney(missing)} PARA ENVÍO GRATIS!`
            : "🎉🚚 ¡ENHORABUENA! EL ENVÍO ES GRATIS";
        }

        if(fillNode){
          fillNode.style.width=`${progress.toFixed(2)}%`;
        }
      }
    }catch(err){}
    finally{
      fetchInFlight=false;
      scheduleOffset();
      if(refreshQueued){
        refreshQueued=!1;
        refreshCart();
      }
    }
  }

  function scheduleRefresh(delay){
    clearTimeout(refreshTimer);
    refreshTimer=setTimeout(refreshCart,typeof delay==="number"?delay:120);
  }

  function boot(){
    if(textNode){
      textNode.textContent="🚚 CARGANDO ENVÍO GRATIS…";
    }
    scheduleOffset();
    refreshCart();
    window.setTimeout(function(){
      if(lastTotal===null){
        refreshCart();
      }
    },700);
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",boot,{once:true});
  }else{
    boot();
  }

  window.addEventListener("pageshow",function(){
    scheduleOffset();
    scheduleRefresh(0);
  });

  window.addEventListener("resize",scheduleOffset,{passive:true});

  if("ResizeObserver" in window){
    new ResizeObserver(scheduleOffset).observe(bar);
  }

  document.addEventListener("click",function(event){
    const target=event.target;
    if(
      target &&
      (
        target.closest('[data-add-to-cart], button[name="add"], .add-to-cart') ||
        target.closest('[data-quantity-plus],[data-quantity-minus],[data-cart-remove],[data-remove],a[href*="/cart/change"]')
      )
    ){
      scheduleRefresh(200);
    }
  },true);

  document.addEventListener("change",function(event){
    const target=event.target;
    if(target && target.name && (target.name.includes("updates") || target.name.includes("quantity"))){
      scheduleRefresh(200);
    }
  },true);

  ["ajaxProduct:added","cart:updated","cart:refresh","cart:rendered","shopify:section:load"].forEach(function(eventName){
    document.addEventListener(eventName,function(){
      scheduleOffset();
      scheduleRefresh(120);
    });
  });

  if(!window.__MIAYMIA_FSB_HOOKED){
    window.__MIAYMIA_FSB_HOOKED=!0;
    const nativeFetch=window.fetch;
    window.fetch=function(){
      const request=arguments[0];
      const url=typeof request==="string"?request:request&&request.url?request.url:"";
      return nativeFetch.apply(this,arguments).then(function(response){
        try{
          if(
            url.includes("/cart/add") ||
            url.includes("/cart/change") ||
            url.includes("/cart/update") ||
            url.includes("/cart/clear")
          ){
            scheduleRefresh(150);
          }
        }catch(err){}
        return response;
      });
    };
  }

  if(!window.__MIAYMIA_FSB_XHR_HOOKED && window.XMLHttpRequest){
    window.__MIAYMIA_FSB_XHR_HOOKED=!0;
    const nativeOpen=XMLHttpRequest.prototype.open;
    const nativeSend=XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open=function(method,url){
      try{ this.__miaymia_url=url; }catch(err){}
      return nativeOpen.apply(this,arguments);
    };

    XMLHttpRequest.prototype.send=function(){
      try{
        this.addEventListener("load",()=>{
          const url=this.__miaymia_url||"";
          if(
            typeof url==="string" &&
            (
              url.includes("/cart/add") ||
              url.includes("/cart/change") ||
              url.includes("/cart/update") ||
              url.includes("/cart/clear") ||
              url.includes("/cart.js")
            )
          ){
            window.setTimeout(function(){ scheduleRefresh(0); },150);
          }
        });
      }catch(err){}
      return nativeSend.apply(this,arguments);
    };
  }
}();

!function(){
  if(window.__MIAYMIA_UIFIXES_HOOKED)return;
  window.__MIAYMIA_UIFIXES_HOOKED=!0;

  let frame=null;
  let observer=null;

  function getHeader(){
    return document.querySelector("#SiteHeader") || document.querySelector(".site-header") || null;
  }

  function updateHeaderState(){
    frame=null;
    const header=getHeader();
    document.documentElement.classList.toggle(
      "miaymia-header-stuck",
      !!(header && header.classList.contains("site-header--stuck"))
    );
  }

  function scheduleHeaderState(){
    if(!frame){
      frame=window.requestAnimationFrame(updateHeaderState);
    }
  }

  function markCollectionToolbar(){
    const toolbar=
      document.querySelector(".collection-filters") ||
      document.querySelector(".collection-toolbar") ||
      document.querySelector(".collection__toolbar") ||
      document.querySelector("[data-collection-toolbar]") ||
      document.querySelector("[data-collection-filters]") ||
      document.querySelector("#CollectionFiltersForm")?.closest("div") ||
      null;

    if(toolbar && !toolbar.classList.contains("miaymia-collection-toolbar")){
      toolbar.classList.add("miaymia-collection-toolbar");
    }
  }

  function bootUiFixes(){
    scheduleHeaderState();
    markCollectionToolbar();

    const header=getHeader();
    if(header && "MutationObserver" in window){
      if(observer) observer.disconnect();
      observer=new MutationObserver(scheduleHeaderState);
      observer.observe(header,{attributes:true,attributeFilter:["class"]});
    }

    window.addEventListener("resize",scheduleHeaderState,{passive:true});
    document.addEventListener("shopify:section:load",function(){
      markCollectionToolbar();
      scheduleHeaderState();
    });
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",bootUiFixes,{once:true});
  }else{
    bootUiFixes();
  }
}();
